import {Component, inject, input, output, viewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridComponent, DxDataGridModule} from 'devextreme-angular';
import {CellClickEvent, ToolbarPreparingEvent} from 'devextreme/ui/data_grid';
import {UtilsService} from '../../../../core/utils/utils.service';
import {
  LigneParametrageFacturationProduitComplementaire
} from '../../../../core/models/facturation/client/ligne-parametrage-facturation-produit-complementaire';
import {
  PeriodeParametrageFacturationProduitComplementaire
} from '../../../../core/models/facturation/client/periode-parametrage-facturation-produit-complementaire';

export interface LigneParametrageProduitComplementaireKey {
  plcId: number;
  produitDeclinaisonId: number;
}

export interface PeriodeBadgeClickEvent {
  ligne: LigneParametrageFacturationProduitComplementaire;
  periode: PeriodeParametrageFacturationProduitComplementaire;
}

@Component({
  selector: 'yo-ligne-parametrage-produit-complementaire-data-grid',
  templateUrl: './ligne-parametrage-produit-complementaire-data-grid.component.html',
  styleUrls: ['./ligne-parametrage-produit-complementaire-data-grid.component.scss'],
  standalone: true,
  imports: [CommonModule, DxDataGridModule]
})
export class LigneParametrageProduitComplementaireDataGridComponent {

  readonly utilsSvc = inject(UtilsService);

  readonly lignes = input<LigneParametrageFacturationProduitComplementaire[]>([]);

  /** Clé composite : (plcId, produitDeclinaisonId) est unique en base, y compris pour les lignes non encore persistées. */
  readonly keyExpr = ['plcId', 'produitDeclinaisonId'];

  readonly periodeBadgeClick = output<PeriodeBadgeClickEvent>();

  readonly taxeCellClick = output<LigneParametrageFacturationProduitComplementaire>();

  private readonly grid = viewChild.required(DxDataGridComponent);

  onToolbarPreparing = (event: ToolbarPreparingEvent): void => {
    event.toolbarOptions.items.unshift(
      {location: 'before', template: 'beforeTemplate'},
      {location: 'after', template: 'afterTemplate'}
    );
  };

  getSelectedData = (): LigneParametrageProduitComplementaireKey[] => this.grid().selectedRowKeys;

  /** DevExtreme ne purge pas automatiquement selectedRowKeys quand une ligne sélectionnée est retirée du dataSource. */
  clearSelection = (): void => {
    this.grid().instance.deselectAll();
  };

  /** Remplace la sélection courante par cette seule ligne (preserve=false) : le clic sur un badge cible une ligne précise. */
  selectOnly = (key: LigneParametrageProduitComplementaireKey): void => {
    this.grid().instance.selectRows([key], false);
  };

  /** Toute la case Taxe est cliquable, pas seulement son libellé : une ligne de staging n'a pas encore de taxe à cliquer. */
  onCellClick = (event: CellClickEvent<LigneParametrageFacturationProduitComplementaire>): void => {
    if (event.rowType === 'data' && event.column?.dataField === 'taxeLibelle') {
      this.taxeCellClick.emit(event.data);
    }
  };

  onPeriodeBadgeClick = (ligne: LigneParametrageFacturationProduitComplementaire,
                         periode: PeriodeParametrageFacturationProduitComplementaire): void =>
    this.periodeBadgeClick.emit({ligne, periode});
}
